export default [
	{
		text: 'Interested',
		type: 1,
		error: false,
		active: false,
		flag: 'clientNotInterested'
	},
	{
		text: 'Not interested',
		type: 2,
		error: false,
		active: false,
		flag: 'clientOther'
	},
	{
		text: 'Voicemail',
		type: 5,
		error: false,
		active: false,
		flag: 'clientVoicemail'
	},
	{
		text: 'Other',
		type: 3,
		error: false,
		active: false,
		flag: 'clientPotential'
	},
	{
		text: 'On-boarded',
		type: 4,
		error: false,
		active: false,
		flag: 'clientInterested'
	}
];
